import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';

@Component({
  selector: 'yi-magento1-load-past-purchases',
  template: require('./magento1_load_past_purchases.component.html'),
  styles: [require('./magento1_load_past_purchases.component.scss')]

})

export class Magento1LoadPastPurchasesComponent extends AccordionContentComponent {

}
